<div id="result">
    <div class="row">
        <div class="col-12">
            <div style="width: 100%; height: 100%">
                <rask-hot-doc
                    [hotDoc]="hotDoc">
                </rask-hot-doc>
            </div>
        </div>
    </div>
</div>